export const breakpoints = {
  xs: "320px",
  sm: "576px",
  md: "768px",
  lg: "960px",
  xl: "1440px",
  "2xl": "1560px",
};
